export default "/img/logo-mark-evergreen.svg"